import { getStyle } from "../../hooks/use-styles";
import { formatCurrency } from "../../utils/common-utils";
import { VOLUME_UNIT } from "../../utils/constants";

import "./style.css";

const PricePerVolumeText = ({ price, currency, volume, showVolume }) => {
  return (
    <div className="price-per-volume" style={{ color: getStyle("black") }}>
      {formatCurrency(+price, currency)}
      {showVolume && (
        <span
          className="text-xs price-per-volume-per-kg"
          style={{ color: getStyle("grey") }}
        >
          {volume || `/${VOLUME_UNIT}`}
        </span>
      )}
    </div>
  );
};

export default PricePerVolumeText;
